import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";

import Loader from "components/commons/Loader/Loader";
import BenefitsListStore from "stores/BenefitsListStore";
import {observer} from "mobx-react-lite";
import BenefitsListTable from "../../components/BenefitsListComponents/BenefitsListTable/BenefitsListTable";
import BenefitsListHeader from "../../components/BenefitsListComponents/BenefitsListHeader/BenefitsListHeader";

const BenefitsListRoute = () => {
  const { benefits } = BenefitsListStore;

  useEffect(() => {
      BenefitsListStore.getBenefits().catch(console.error);
  }, []);

  if (!benefits) {
    return <Loader />;
  }

  return (
    <>
      <BenefitsListHeader />
      <BenefitsListTable />
    </>)
};

export default withRouter(observer(BenefitsListRoute));
